/**
 * @author  Muhanad Abdalla <muhanad.abdalla@aofl.com>
 */
define([], function() {
  'use strict';
   /* eslint-enable */

  /**
   * @function transformObjectKeys
   * @param {function} transformFn - transformation to apply to all object keys
   * @return {function} function that takes an object to deep transform its keys.
   * */
  function transformObjectKeys(transformFn) {
    return function(input) {
      // eslint-disable-line
      if (typeof input !== 'object' || input === null) {
        return input; // return arguments[0];
      }
      if (Array.isArray(input)) {
        return input.map(transformObjectKeys(transformFn));
      }
      return Object.keys(input).reduce(function(_transformed, key) {
        // eslint-disable-line
        _transformed[transformFn(key)] = transformObjectKeys(transformFn)(
          input[key]
        );
        return _transformed;
      }, {});
    };
  }

  var snakeCase = function snakeCase(str) {
    return (
      str[0].toLowerCase() +
      str.slice(1).replace(/([A-Z|0-9]+)/g, function snakeReplace(m, x) {
        return '_' + x.toLowerCase();
      })
    );
  };

  return {
    mapKeys: (transformObjectKeys),
    snakeCaseKeys: (transformObjectKeys)(snakeCase)
  };  
});
